// Foundations
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';

// Services
import { CognitoService } from '../../../services/cognito.service';
import { LoadingIndicatorService } from 'src/app/services/loading-indicator.service';
import { finalize } from 'rxjs/operators';
import { AnalyticsService } from 'src/app/services/analytics.service';

// Components
import { ConfirmDialogComponent } from '../../_share/confirm-dialog/confirm-dialog.component';


const EMAIL_REGEX = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/;

@Component({
  selector: 'app-forgot-password-email',
  templateUrl: './forgot-password-email.component.html',
  styleUrls: ['./forgot-password-email.component.scss'],
})
export class ForgotPasswordEmailComponent implements OnInit {
  @Output() changeStep = new EventEmitter<number>();
  @Output() email = new EventEmitter<string>();

  form: FormGroup;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private dialog: MatDialog,
    private cognitoService: CognitoService,
    private loadingIndicatorService: LoadingIndicatorService,
    private _analytics: AnalyticsService
  ) {
    this.form = this.fb.group({
      email: [
        '',
        { validators: [Validators.required, Validators.pattern(EMAIL_REGEX)] },
      ],
    });
  }

  // Life cycles
  // ------------------------------------------------------------------------------------

  ngOnInit(): void {
    this._analytics.logScreen('signInForgotPasswordSubmitPage');

    this.form.get('email').valueChanges.subscribe((res) => {
      this.form.patchValue(
        { email: this.form.get('email').value.toLowerCase() },
        { emitEvent: false }
      );
    });
  }

  // Public Methods
  // ------------------------------------------------------------------------------------

  get f(): any {
    return this.form.controls;
  }

  cancel(): void {
    this._analytics.logButtonTap('signInForgotPasswordSubmit_cancel');
    this.router.navigate(['/sign-in']);
  }

  onSubmit(): void {
    this._analytics.logButtonTap(
      'signInForgotPasswordSubmit_sendVerificationCode'
    );

    const { email } = this.form.value;
    this.loadingIndicatorService.show();
    this.cognitoService
      .confirmSignUp(email, 'xxxxxx')
      .pipe(finalize(() => this.loadingIndicatorService.hide()))
      .subscribe((res) => {
        if (res.result === 'UserNotFoundException') {
          this.dialog.open(ConfirmDialogComponent, {
            panelClass: 'general-dialog',
            data: {
              title: 'Email Not Found',
              content: `This email does not exist in our system. Please check your input and try again.`,
              okText: 'OK',
            },
            autoFocus: false,
            disableClose: true,
          });
        } else {
          this.cognitoService.forgotPassword(email);
          this.changeStep.emit(1);
          this.email.emit(email);
        }
      });
  }
}
